module.exports = __webpack_public_path__ + "img/loginTitle.6f5ba20f.png";